import { render, staticRenderFns } from "./LaddaButton.vue?vue&type=template&id=68f60fde&scoped=true&"
import script from "./LaddaButton.vue?vue&type=script&lang=tsx&"
export * from "./LaddaButton.vue?vue&type=script&lang=tsx&"
import style0 from "./LaddaButton.vue?vue&type=style&index=0&id=68f60fde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f60fde",
  null
  
)

export default component.exports